module.exports = __webpack_public_path__ + "../resources/images/illustration_access_error-f05459cfc6d9ca889ac885be958f5f86.svg";